import React, { useState, useEffect, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import { format } from "date-fns";
import ChoVayApi from "service/choVayApi";
import userApi from "service/userApi";
import { SearchBarHopDong } from "./SearchBarDestop";
import { TableDanhSach } from "./TableDanhSach";
import { BtnXuatExcel } from "./BtnXuatExcel";
import { BtnIn } from "./BtnIn";
import ChiTietHopDong from "service/chiTietHopDongApi";
import ChiTietHopDongContainer from 'containers/Common/QuanLyChoVay/ChiTietHopDongContainerV2';
import CustomerDetail from 'containers/Common/Customer/customerDetail';
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
export const ModalChonHopDong = ({ show, onHide, onContractSelected }) => {
    const initialDataSearch = {
        name: "",
        dateTo: null,
        type: "0",
        debtLevel: "-1",
        code: "",
        statusGiaHan: "0",
        user: "0",
        address: "",
        pageIndex: 1,
        pageSize: 20,
    };

    const [dataSearch, setDataSearch] = useState(initialDataSearch);
    const [listHopDong, setListHopDong] = useState({ List: [], iTotal: 0 });
    const [isLoading, setIsLoading] = useState(false);
    const [selectedHopDong, setSelectedHopDong] = useState(null);
    const [nguoiTaoOptions, setNguoiTaoOptions] = useState([]);
    const [showModalHopDong, setShowModalHopDong] = useState(false);
    const [showModalKhachHang, setShowModalKhachHang] = useState(false);
    const [modalKhachHangData, setModalKhachHangData] = useState(null);
    const [hopDongDetail, setHopDongDetail] = useState(null);
    const [hideParent, setHideParent] = useState(false);
    const [tinhTrangOptions, setTinhTrangOptions] = useState([]);
    const loadNguoiTao = useCallback(() => {
        userApi.combo2()
            .then(res => {
                if (res.status === 200 && res.data) {
                    const allOption = { value: "0", label: "Tất cả" };
                    const formattedOptions = res.data.map(user => ({
                        value: user.value,
                        label: user.label
                    }));
                    setNguoiTaoOptions([allOption, ...formattedOptions]);
                }
            })
            .catch(error => {
                console.error("Lỗi khi tải danh sách người tạo:", error);
            });
    }, []);

    const loadTinhTrangNo = useCallback(() => {
        DoiTinhTrangNoApi.getListTinhTrangNo()
            .then(res => {
                if (res.status === 200 && res.data) {
                    const formattedOptions = res.data.map(item => ({
                        value: item.Code,
                        label: item.Name
                    }));
                    const allOption = { value: "-1", label: "Tất cả" };
                    setTinhTrangOptions([allOption, ...formattedOptions]);
                }
            })
            .catch(error => {
                console.error("Lỗi khi tải danh sách tình trạng nợ:", error);
                setTinhTrangOptions([{ value: "-1", label: "Tất cả" }]);
            });
    }, []);
    const handleGetData = useCallback((searchParams) => {
        setIsLoading(true);
        const actualDateTo = searchParams.dateTo || new Date();

        const params = {
            ...searchParams,
            dateTo: format(actualDateTo, 'dd/MM/yyyy'),
        };

        ChoVayApi.getDanhSachNo(params)
            .then(res => {
                if (res.status === 200) {
                    setListHopDong({
                        List: res.data.List || [],
                        iTotal: res.data.iTotal || 0,
                        TotalSoTienVay: res.data.TotalSoTienVay || 0,
                        TotalSoTienDaTra: res.data.TotalSoTienDaTra || 0,
                        TotalSoTienThanhToan: res.data.TotalSoTienThanhToan || 0,
                    });
                } else {
                    setListHopDong({ List: [], iTotal: 0, TotalSoTienVay: 0, TotalSoTienDaTra: 0, TotalSoTienThanhToan: 0 });
                }
            })
            .catch(() => setListHopDong({ List: [], iTotal: 0, TotalSoTienVay: 0, TotalSoTienDaTra: 0, TotalSoTienThanhToan: 0 }))
            .finally(() => setIsLoading(false));
    }, []);

    useEffect(() => {
        loadNguoiTao();
        loadTinhTrangNo();
        handleGetData(initialDataSearch);
    }, []);

    const handleConfirmSelection = () => {
        if (selectedHopDong) {
            onContractSelected(selectedHopDong);
            onHide();
        } else {
            alert("Vui lòng chọn một hợp đồng.");
        }
    };
    const handleOpenModalHopDong = (item) => {
        setShowModalHopDong(true);
        setHideParent(true);
        ChiTietHopDong.getChiTietHopDong1(item.ChoVayID).then((response) => {
            setHopDongDetail(response.data);
        });
    };
    const handleCloseModalHopDong = () => {
        setShowModalHopDong(false);
        setHideParent(false);
        setHopDongDetail(null);
    };
    const handleOpenModalKhachHang = (item) => {
        setModalKhachHangData(item);
        setShowModalKhachHang(true);
        setHideParent(true);
    };
    const handleCloseModalKhachHang = () => {
        setShowModalKhachHang(false);
        setHideParent(false);
    };
    return (<>
        <Modal show={show && !hideParent} onHide={onHide} size="xl" centered backdrop="static" className="modal-new modal fade text-left" scrollable={true}>
            <div className="modal-content" style={{
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh'
            }}>
                <Modal.Header>
                    <h4 className="modal-title color7-bold">
                        <span className="btn-icon-right"><img
                            src="/app-assets/images/icon-tao-moi-don-nhap-hang.png"
                            alt="icon"
                        /></span>
                        Chọn mã hợp đồng
                    </h4>
                    <button
                        type="button"
                        className="close-popup-new"
                        onClick={onHide}
                    >
                        <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                    </button>
                </Modal.Header>
                <Modal.Body style={{ position: 'relative', overflowY: 'auto' }}>
                    <div style={{
                        position: 'absolute',
                        top: '0px',
                        right: '20px',
                        zIndex: 10,
                        display: 'flex',
                        gap: '10px'
                    }}>
                        <BtnIn dataSearch={dataSearch} />
                        <BtnXuatExcel params={dataSearch} />
                    </div>
                    <SearchBarHopDong
                        dataSearch={dataSearch}
                        setDataSearch={setDataSearch}
                        onSearch={handleGetData}
                        nguoiTaoOptions={nguoiTaoOptions}
                        tinhTrangOptions={tinhTrangOptions}
                    />
                    <TableDanhSach
                        listHopDong={listHopDong}
                        isLoading={isLoading}
                        dataSearch={dataSearch}
                        setDataSearch={setDataSearch}
                        onSearch={handleGetData}
                        selectedHopDong={selectedHopDong}
                        setSelectedHopDong={setSelectedHopDong}
                        onOpenModalHopDong={handleOpenModalHopDong}
                        onOpenModalKhachHang={handleOpenModalKhachHang}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-new-main btn-closenew" onClick={onHide}>
                        <span><i className="mdi mdi-close"></i></span>&nbsp; Đóng
                    </button>
                    <button type="button" className="btn btn-new-main button-popup-submit" onClick={handleConfirmSelection}>
                        <span><img src="/app-assets/images/icon-send-v2.png" alt="save" /></span>&nbsp; CHỌN
                    </button>
                </Modal.Footer>
            </div>
        </Modal>
        {showModalHopDong && hopDongDetail && (
            <ChiTietHopDongContainer
                show={showModalHopDong}
                onHide={handleCloseModalHopDong}
                data={hopDongDetail}
                setModalTaiSan={() => { }}
            />
        )}
        {showModalKhachHang && modalKhachHangData && (
            <CustomerDetail
                show={showModalKhachHang}
                onHide={handleCloseModalKhachHang}
                data={{ CustomerID: modalKhachHangData.CustomerID }}
            />
        )}
    </>
    );
};